import React from 'react';

import Loading from './Loading';

export function LoadingOverlay({
  type = 'button',
  showText = true,
  text,
  className = '',
  size = 64,
}) {
  return (
    <div className="loading-overlay">
      <Loading {...{ type, showText, text, className, size }} />
    </div>
  )
}
